import { container } from 'tsyringe';

export default defineNuxtPlugin({
  name: 'ioc',
  parallel: true,
  enforce: 'pre', // pre|default|post
  setup() {
    return {
      provide: {
        ioc: container,
      },
    };
  },
});
